import React, { useRef, useEffect } from "react";

const CustomCheckbox = ({
  checked,
  onChange,
  disabled = false,
  shape = "square",
  indeterminate = false,
  ariaLabel,
}) => {
  const inputRef = useRef(null);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.indeterminate = indeterminate;
    }
  }, [indeterminate]);

  const roundedClass = shape === "circle" ? "rounded-full" : "rounded";

  return (
    <div className="flex justify-center">
      <label
        className={`inline-flex relative ${
          disabled ? "cursor-not-allowed opacity-50" : ""
        }`}
      >
        <input
          ref={inputRef}
          type="checkbox"
          className="peer sr-only"
          aria-label={ariaLabel}
          checked={checked}
          onChange={onChange}
          disabled={disabled}
        />
        <span
          className={`w-4 h-4 ${roundedClass} border peer-focus-visible:ring-2 peer-focus-visible:ring-secondary peer-focus-visible:ring-offset-2 ${
            checked || indeterminate
              ? "bg-secondary border-secondary"
              : "border-gray-400 bg-white"
          } flex items-center justify-center ${
            disabled ? "cursor-not-allowed" : "cursor-pointer"
          }`}
        >
          {indeterminate && !checked ? (
            <span className="block w-2 h-0.5 bg-white rounded" />
          ) : checked ? (
            <svg
              className="w-3 h-3 text-white"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="3"
                d="M5 13l4 4L19 7"
              />
            </svg>
          ) : null}
        </span>
      </label>
    </div>
  );
};

export default CustomCheckbox;
